export default __webpack_public_path__ + "static/media/30-Alibaba.ad665c1f.jpg";